<template>
  <div id="finance" class="wrrapper">
    <page-heading title="Finance Report">
      <template #content>
        <div class="flex align-center no-print">
          <Select
            placeholder="Filter by"
            :loading="loading"
            :options="listDoctors"
            :input="handleFilters"
          />
          <DateRangePicker @update="updateDate" />
          <Select
            v-if="isAdmin"
            class="ml-2"
            styles="expenses-select"
            placeholder="Filter by Branch"
            :input="handleBranchChange"
            :options="brachData"
          />
          <ExportButtons
            style="margin-left: 8px;"
            @pdf="handleExportPdf"
            @excel="handleExportExcel"
          />
        </div>
      </template>
    </page-heading>
    <div id="finance--report">
      <div class="print-header">
        <div
          style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;"
        >
          <img
            :src="bussinessLogoUrl"
            alt="Logo"
            style="height: 50px; max-width: 200px;"
            v-if="bussinessLogoUrl"
          />
          <div style="flex: 1; text-align: center;">
            <h2 style="margin: 0; font-size: 1.5rem;">
              Finance Reports - UCEMR
            </h2>
            <div style="font-size: 1rem; margin-top: 0.5rem;">
              <span
                >Date: {{ filters.start_date }} to {{ filters.end_date }}</span
              >
            </div>
          </div>
          <div style="text-align: right; min-width: 150px;">
            <div>Printed by: {{ user.full_name }}</div>
            <div>{{ new Date().toLocaleDateString() }}</div>
          </div>
        </div>
        <hr style="margin: 0 0 1rem 0;" />
      </div>
      <data-table
        class="no-print"
        :loading="loading"
        :cols="columns"
        :rows="reportsList"
        total
      >
      </data-table>
      <FinancePrintTable
        class="print-only"
        :columns="columns"
        :rows="reportsList"
        :sum="sum"
        :mediTotal="mediTotal"
        :organizationTotal="organizationTotal"
        :formatNumber="formatNumber"
      />
      <div class="print-report flex justify-end mr-4 mb-2 no-print">
        <div>
          <div class="percent flex" style="justify-content: space-between;">
            <h2 class="net-total">Net Total</h2>
            <h2>PKR {{ sum }}</h2>
          </div>
          <div
            class="percent flex"
            v-if="user.tenantId === 1 && user.userRole[0].id !== 6"
          >
            <h2 class="total">Medi Rad Total</h2>
            <h2>PKR {{ mediTotal | formatNumber }}</h2>
          </div>
          <div
            class="percent flex"
            v-if="user.tenantId === 1 && user.userRole[0].id !== 6"
          >
            <h2 class="total">Organization Total</h2>
            <h2>PKR {{ organizationTotal | formatNumber }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapActions, mapGetters } from "vuex";
import { formatedDate, getPercentage, formatNumbers } from "@/utils/helpers";
import DateRangePicker from "@/components/DateRangePIcker";
import Select from "@/components/Select";
import FinancePrintTable from "@/components/FinancePrintTable.vue";
import { getBranchLogo } from "../../utils/helpers";
import { permissionsMiddleWare } from "../../utils/permissionsMiddleWare";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
export default {
  components: {
    DateRangePicker,
    DataTable,
    Select,
    FinancePrintTable,
    ExportButtons
  },
  data() {
    return {
      filters: {
        end_date: formatedDate(),
        start_date: formatedDate(),
        service_head: "",
        branchId: null
      },
      sum: null,
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "date",
          label: "Date",
          sortable: true
        },
        {
          column: "gross_income",
          label: "Gross Total",
          sortable: true,
          sum: true
        },
        {
          column: "total_discount",
          label: "Total Discount",
          sortable: true,
          sum: true
        },
        {
          column: "today_receivables",
          label: "Receiveables",
          sortable: true,
          sum: true
        },
        {
          column: "net_total",
          label: "Net Total",
          sortable: true,
          sum: true
        }
      ],
      brachData: [],
      isAdmin: null,
      bussinessLogoUrl: "",
      branchLogoUrl: ""
    };
  },
  methods: {
    ...mapActions("reports", ["listReports", "listReportsByBranch"]),
    ...mapActions("doctors", ["doctorList"]),
    ...mapActions("expenses", ["fetchBranch"]),
    updateDate(val) {
      if (permissionsMiddleWare("Finance Report")) {
        this.filters.end_date = formatedDate(val.endDate);
        this.filters.start_date = formatedDate(val.startDate);
        this.listReports(this.filters);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Finance Report"
          )
          .goAway("3000");
      }
    },
    exportInput() {
      const summary = [
        { label: "Gross Total", value: "PKR " + formatNumbers(this.grossTotal) }
      ];
      return {
        title: "Finance Reports - UCEMR",
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        printedBy: this.user.full_name,
        businessLogoUrl: this.bussinessLogoUrl,
        branchLogoUrl: this.branchLogoUrl,
        cols: this.columns,
        rows: this.reportsList,
        summary,
        fileName: "finance-report"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleFilters(val) {
      if (permissionsMiddleWare("Finance Report")) {
        const id = val && val.id !== null ? val.id : "";
        this.filters.service_head = id;
        this.listReports(this.filters);
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Finance Report"
          )
          .goAway("3000");
      }
    },
    handleBranchChange(val) {
      if (val && val != null) {
        const object = getBranchLogo(this.fetchUserBranch, val.key);
        this.branchLogoUrl = object;
        this.filters.branchId = val.key;
        this.listReportsByBranch(this.filters);
      }
      if (val === null) {
        delete this.filters.branchId;
        this.listReportsByBranch(this.filters);
      }
    },
    formatNumber(val) {
      // Use the global filter or helper directly
      return this.$options.filters && this.$options.filters.formatNumber
        ? this.$options.filters.formatNumber(val)
        : typeof this.$root.$options.filters?.formatNumber === "function"
        ? this.$root.$options.filters.formatNumber(val)
        : val;
    }
  },
  computed: {
    ...mapGetters({
      reportsList: "reports/reportsList",
      listDoctors: "doctors/listDoctors",
      financeList: "doctors/financeList",
      role: "auth/role",
      loading: "loading",
      user: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch",
      settings: "bussiness/settings",
      lookupList: "bussiness/lookupList"
    }),
    mediTotal() {
      const mediradTotal =
        this.financeList?.find(item => item.type === "medirad_total")
          ?.description || "80";
      return getPercentage(this.sum, Number(mediradTotal));
    },
    organizationTotal() {
      const orgTotal =
        this.financeList?.find(item => item.type === "org_total")
          ?.description || "20";
      return getPercentage(this.sum, Number(orgTotal));
    },
    roleId() {
      const { id } = this.role && this.role.find(item => item);
      return id;
    },
    grossTotal() {
      return (this.reportsList || []).reduce(
        (accum, item) => accum + Number(item.gross_income || 0),
        0
      );
    }
  },
  watch: {
    reportsList(val) {
      let sum = 0;
      val &&
        val.map(item => {
          const value = Number(item.net_total);
          sum += value;
        });
      this.sum = sum.toFixed(2);
    }
  },
  filters: {
    formatNumber(val) {
      return formatNumbers(val);
    }
  },
  async mounted() {
    this.isAdmin = this.user.userRole.some(({ name }) => name === "admin");
    await this.fetchBranch();
    if (permissionsMiddleWare("Finance Report")) {
      this.listReports(this.filters);
    } else {
      this.$toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Finance Report"
        )
        .goAway("3000");
    }

    await this.doctorList("servicehead");
    await this.doctorList("finance_divident");

    console.log(this.financeList, "d");

    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    this.bussinessLogoUrl = this.user?.bussinessLogoUrl;

    this.branchLogoUrl = getBranchLogo(
      this.fetchUserBranch,
      this.user.userBranchId
    );
  }
};
</script>

<style scoped>
@import "../../assets/css/reportPrint.css";

.percent {
  margin-bottom: 10px;
}

.percent h2 {
  font-weight: 400;
  margin: 0;
  font-size: var(--fs-body);
  line-height: 30px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: var(--text);
}

.percent .total {
  width: 150px;
  margin-right: 30px;
  color: var(--muted);
}

.percent .net-total {
  width: 150px;
  margin-right: 30px;
  font-weight: 600;
  font-size: var(--fs-body);
  color: var(--ink-900);
}

@media print {
  .print-report {
    margin: 0 !important;
  }

  .percent h2 {
    margin: 0;
    font-size: 8pt;
  }

  .percent .net-total {
    margin-right: 10px;
    font-weight: 500;
    font-size: 8pt;
  }

  .percent .total {
    margin-right: 10px;
  }

  .percent {
    margin: 0;
  }
}
</style>
